<!-- @if(stateName!='' && districtName!=''){ -->
<div class="updateContainer">
  <div class="d-flex justify-content-between gap-2" style="margin-bottom: 1rem;">
    <input type="text" class="dp-input-control btn-div 2" [style.width]="!isMobileDevice?'20%':'100%'" [formControl]="searchReq"
      placeholder="Search in displayed result">
    @if(superUser || (stateName!=='' && districtName !=='')){
    <button class="dp-primary-btn btn-div d-flex gap-2 align-items-center" (click)="onFilterClick()">
      <img src="../../../assets/filter.svg" />
      <span class="filter-text">{{!isMobileDevice?'Filter':''}}</span></button>
    }
  </div>
  <div class="tableSec">
    @if(!isMobileDevice){
    @if(districtName==='' && stateName===''){
    @if(isLoader){
    <table class="dp-table">
      <thead class="dp-table-header">
        <tr>
          <th>Country</th>
          <th>State</th>
          <th>Count</th>
        </tr>
      </thead>
      <tbody class="dp-table-body">
        <tr *ngFor="let i of [].constructor(5)">
          <td *ngFor="let j of [].constructor(7)">
            <dp-loader></dp-loader>
          </td>
        </tr>
      </tbody>
    </table>
    }
    @else{
    <dp-table [dataTable]="responseData" [displayedColumns]="displayStateColumnData"
      [componentMap]="cellComponentMapState" (cellClick)="openDistrictCount($event)"></dp-table>
    }
    }
    @else if(stateName!=='' && districtName ===''){
    @if(isLoader){
    <table class="dp-table">
      <thead class="dp-table-header">
        <tr>
          <th>State</th>
          <th>District</th>
          <th>Count</th>
        </tr>
      </thead>
      <tbody class="dp-table-body">
        <tr *ngFor="let i of [].constructor(5)">
          <td *ngFor="let j of [].constructor(7)">
            <dp-loader></dp-loader>
          </td>
        </tr>
      </tbody>
    </table>
    } @else{
    <dp-table [dataTable]="responseData" [displayedColumns]="displayColumnDataForDistrict"
      [componentMap]="cellComponentMapDistrict" (cellClick)="openDataTable($event)"></dp-table>}
    }
    @else{
    @if(isLoader){
    <table class="dp-table">
      <thead class="dp-table-header">
        <tr>
          <th>Sl.No</th>
          <th>Full Name</th>
          <th>Status</th>
          <th>Family Code</th>
          <th>Updated By</th>
          <th>Reviewed By</th>
          <th>Updated On</th>
          <th>Count</th>
        </tr>
      </thead>
      <tbody class="dp-table-body">
        <tr *ngFor="let i of [].constructor(5)">
          <td *ngFor="let j of [].constructor(7)">
            <dp-loader></dp-loader>
          </td>
        </tr>
      </tbody>
    </table>
    } @else{
    <div class="dp-table-scroll" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="1000" (scrolled)="onScroll()" #tableContainer>
      <dp-table [dataTable]="responseData" [displayedColumns]="displayColumnData" [componentMap]="cellComponentMap"
        [columnConfs]="columnConfs" (cellClick)="openDialog($event)"></dp-table>
    </div>
    }
    }
    }@else{
    <div class="tableBoxMob">
      <div class="dataList">
        @if(districtName==='' && stateName===''){
        @if(isLoader){
        <div *ngFor="let i of [].constructor(10)">
          <ul class="eachdataList">
            <li class="data">
              Country
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
            <li class="data">
              State
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
            <li class="data">
              Count
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
          </ul>
        </div>
        }
        @else{
        @if(responseData.length===0){
        <div class="noData">
          <div class="placeholderTable"></div>
          <p>No data found!</p>
        </div>
        }@else{
        <div class="tableBoxMob">
          <div class="dataList">
            @for( lists of responseData; track lists){
            <ul class="eachdataList">
              <li class="data">
                Country
                <span class="data">{{ lists.country }}</span>
              </li>
              <li class="data">
                State<span style="color:var(--brand-primary)" (click)="openDistrictCount(lists.stateName)">{{
                  lists.stateName
                  }}</span>
              </li>
              <li class="data">
                Count <span>{{ lists.pending || "-" }}</span>
              </li>
            </ul>
            }
          </div>
        </div>
        }
        }
        }@else if(districtName==='' && stateName!=''){
        @if(isLoader){
        <div *ngFor="let i of [].constructor(10)">
          <ul class="eachdataList">
            <li class="data">
              State
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
            <li class="data">
              District
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
            <li class="data">
              Count
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
          </ul>
        </div>
        }@else{
        @if(responseData.length===0){
        <div class="noData">
          <div class="placeholderTable"></div>
          <p>No data found!</p>
        </div>
        }@else{
        <div class="tableBoxMob">
          <div class="dataList">
            @for( lists of responseData; track lists){
            <ul class="eachdataList">
              <li class="data">
                State
                <span class="data">{{ lists.stateName }}</span>
              </li>
              <li class="data">
                District<span style="color:var(--brand-primary)" (click)="openDataTable(lists.districtName)">{{
                  lists.districtName
                  }}</span>
              </li>
              <li class="data">
                Count <span>{{ lists.pending || "-" }}</span>
              </li>
            </ul>
            }
          </div>
        </div>
        }
        }
        }@else{
        @if(isLoader){
        <div *ngFor="let i of [].constructor(10)">
          <ul class="eachdataList">
            <li class="data">
              Sl.No
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
            <li class="data">
              Full name
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
            <li class="data">
              Family Code
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
            <li class="data">
              Guardian
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
            <li class="data">
              FW Name
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
            <li class="data">
              Updated on
              <div class="loader-div"><dp-loader></dp-loader></div>
            </li>
          </ul>
        </div>
        }@else{ @if(responseData.length===0){
        <div class="noData">
          <div class="placeholderTable"></div>
          <p>No data found!</p>
        </div>
        }@else{
        <div class="dp-table-scroll" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"
          [infiniteScrollThrottle]="1000" (scrolled)="onScroll()" #tableContainer>
          <div class="tableBoxMob">
            <div class="dataList">
              @for( lists of responseData; track lists){
              <ul class="eachdataList">
                <li class="data">
                  Sl.No
                  <span class="serial-no">{{ lists.memberKey }}</span>
                </li>
                <li class="data">
                  Full name<span>{{ lists.fullName }}</span>
                </li>
                <li class="data">
                  Status @if(lists.memStatus == 2){<span>Active</span>} @else {
                  <span>Inactive</span>
                  }
                </li>
                <li class="data">
                  Family code <span>{{ lists.philMemberCode || "-" }}</span>
                </li>
                <li class="data">
                  Guardian <span>{{ lists.guardianName }}</span>
                </li>
                <li class="data">
                  Updated By
                  <span class="clickable-mob" (click)="mobOnClick(lists, 'fw')">{{ lists.updatedBy }}</span>
                </li>
                <li class="data">
                  Reviewed By
                  <span class="clickable-mob" (click)="mobOnClick(lists, 'da')">{{ lists.reviewedBy }}</span>
                </li>
                <li class="data">
                  Updated on <span>{{ lists.updatedAt | date }}</span>
                </li>
                <li class="data">
                  Count
                  <span class="clickable-mob" (click)="mobOnClick(lists, 'count')">{{ lists.updateCount }}</span>
                </li>
                <div class="">
                  <button class="dp-secondary-btn w-100 btn-div" (click)="openDialog(lists)">
                    Manage
                  </button>
                </div>
              </ul>
              }
            </div>
          </div>
        </div>
        } }
        }
      </div>
    </div>
    }
  </div>
</div>
<!-- } -->
<app-loader [isLoading]="isLoading"></app-loader>